import { Modal, Typography } from '@mui/material';
import React from 'react';
import CustomButton from '../../shared/button/CustomButton';
import { STyledOptionsFilterBox, StyledTypo3 } from './Search.styled';
import useHandleClickFavourites from '../../shared/hooks/useHandleClickFavourites';

type OptionsFilterModalProps = {
  handleClose: () => void;
  selectAllTeams: () => void;
};
const OptionsFilterModal: React.FC<OptionsFilterModalProps> = ({
  handleClose,
  selectAllTeams,
}) => {
  const { resetTeams: resetFavourites } = useHandleClickFavourites();
  return (
    <>
      <Modal
        open={true}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <STyledOptionsFilterBox>
          <Typography variant="h6" component="h2">
            Options
          </Typography>
          <Typography variant="caption">Options</Typography> <br />
          <CustomButton
            label="- Select all teams"
            onClick={selectAllTeams}
            variant="contained"
          />{' '}
          <br /> <br />
          <StyledTypo3>
            <CustomButton
              label="- Reset your favourites"
              onClick={resetFavourites}
              variant="contained"
            />
          </StyledTypo3>
        </STyledOptionsFilterBox>
      </Modal>
    </>
  );
};
export default OptionsFilterModal;
